import { CopyToClipboard } from "@gearbox-protocol/deploy-tools-ui";
import { CodeEditor } from "components/editors";
import type { FC } from "react";

interface ForkYamlProps {
  code: string;
  setCode: (code: string) => void;
}

const ForkYaml: FC<ForkYamlProps> = ({ code, setCode }) => {
  return (
    <div className="border border-border rounded-md mt-2 relative overflow-hidden">
      <CodeEditor
        language="yaml"
        className="[&_.cm-content]:min-h-96 [&_.cm-gutter]:min-h-96"
        value={code}
        onChange={setCode}
      />

      <div className="p-1 rounded hover:bg-black/15 absolute right-1 top-1">
        <CopyToClipboard text={code} />
      </div>
    </div>
  );
};

export default ForkYaml;
